<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import measurementUnitsApi from "@/api/resources/measurementUnitsApi";
import VSelect from "@/components/VSelect.vue";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getOrderStatuses() {
      measurementUnitsApi.index().then((response) => {
        this.options = response.data.map((unit) => {
          return { text: unit.name, value: unit.id };
        });
      });
    },
  },

  created() {
    this.getOrderStatuses();
  },
};
</script>

<style></style>
